const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-FileSelector',
			DefaultInputExtensions: [ 'FileSelector' ],
			Template: /*HTML*/`
			<!-- InputType FileSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<input
					id="{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					{~D:Record.Macro.InputFullProperties~}
					{~D:Record.Macro.InputChangeHandler~}
				/>
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control control-status is-expanded">
						<!-- the file input control -->
						<div {~D:Record.Macro.ControlAttr~} id="CONTROL-FOR-{~D:Record.Macro.RawHTMLID~}" class="file is-link">
							<label class="file-label">
								<input
									id="FILE-INPUT-FOR-{~D:Record.Macro.RawHTMLID~}"
									class="file-input"
									type="file"
									name="resume"
									onchange="{~P~}.providers.FileSelector.handleFileSelection('{~D:Record.Macro.RawHTMLID~}', false);"
								/>
								<span class="file-cta">
									<span class="file-icon">
										<i class="fas fa-upload"></i>
									</span>
									<span class="file-label"> Upload a file</span>
								</span>
							</label>
							<button type="button" class="button is-link ml-1" onclick="{~P~}.providers.FileSelector.openObservationSearchPanel('{~D:Record.Macro.RawHTMLID~}', '{~D:Context[0].Hash~}', '{~D:Record.Hash~}', false);">
								<span class="icon">
									<i class="fas fa-fw fa-paperclip"></i>
								</span>
								<span>Select Observation</span>
							</button>
						</div>
						<!-- the loading indicator, shown while the file is being processed -->
						<div id="LOADING-FOR-{~D:Record.Macro.RawHTMLID~}" class="is-skeleton is-hidden" style="height: 40px;">Loading...</div>
						<!-- dynamically filled with the preview of the file, if a record exists -->
						<div id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="input is-static is-hidden"></div>
					</p>
					<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-FileSelector',
			DefaultInputExtensions: [ 'FileSelector' ],
			Template: /*HTML-Partial*/`
			<!-- InputType FileSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field mb-0">
				<p class="control control-status is-expanded">
					<input
						id="TABULAR-DATA-FOR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="hidden"
						tabindex="-1"
						{~D:Record.Macro.InformaryTabular~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-FileSelector',
			DefaultInputExtensions: [ 'FileSelector' ],
			Template: /*HTML-Partial*/`
					 />
					<!-- the file input control -->
					<div {~D:Record.Macro.ControlAttr~} id="TABULAR-CONTROL-FOR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}" class="file is-link">
						<label class="file-label">
							<input
								id="TABULAR-FILE-INPUT-FOR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
								class="file-input"
								type="file"
								name="resume"
								onchange="{~P~}.providers.FileSelector.handleFileSelection('{~D:Record.Macro.RawHTMLID~}', true, {~D:Context[2].Key~});"
							/>
							<span class="file-cta">
								<span class="file-icon">
									<i class="fas fa-upload"></i>
								</span>
								<span class="file-label"> Upload a file</span>
							</span>
						</label>
						<button type="button" class="button is-link ml-1" onclick="{~P~}.providers.FileSelector.openObservationSearchPanel('{~D:Record.Macro.RawHTMLID~}', '{~D:Context[0].Hash~}', '{~D:Record.Hash~}', true, {~D:Context[2].Key~});">
							<span class="icon">
								<i class="fas fa-fw fa-paperclip"></i>
							</span>
							<span>Select Observation</span>
						</button>
					</div>
					<!-- the loading indicator, shown while the file is being processed -->
					<div id="TABULAR-LOADING-FOR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}" class="is-skeleton is-hidden" style="height: 40px;">Loading...</div>
					<!-- dynamically filled with the preview of the file, if a record exists -->
					<div id="TABULAR-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}" class="input is-static is-hidden"></div>
				</p>
			</div>
			<p class="help"></p>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-FileSelector',
			DefaultInputExtensions: [ 'FileSelector' ],
			Template: /*HTML*/`
			<!-- InputType FileSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<input
					id="{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					{~D:Record.Macro.InputFullProperties~}
				/>
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control control-status is-expanded">
						<!-- the file input control -->
						<div {~D:Record.Macro.ControlAttr~} id="CONTROL-FOR-{~D:Record.Macro.RawHTMLID~}" class="is-fullwidth">
							<div class="input is-static has-text-text-60"><em>No file selected.</em></div>
						</div>
						<!-- dynamically filled with the preview of the file, if a record exists -->
						<div id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="input is-static is-hidden"></div>
					</p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-FileSelector',
			DefaultInputExtensions: [ 'FileSelector' ],
			Template: /*HTML-Partial*/`
			<!-- InputType FileSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<p class="control control-status is-expanded">
				<input
					id="TABULAR-DATA-FOR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					type="hidden"
					tabindex="-1"
					{~D:Record.Macro.InformaryTabular~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-FileSelector',
			DefaultInputExtensions: [ 'FileSelector' ],
			Template: /*HTML-Partial*/`
					 />
					<!-- the file input control -->
					<div {~D:Record.Macro.ControlAttr~} id="TABULAR-CONTROL-FOR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}" class="is-expanded">
						<div class="input is-static has-text-text-60"><em>No file selected.</em></div>
					</div>
					<!-- dynamically filled with the preview of the file, if a record exists -->
					<div id="TABULAR-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}" class="input is-static is-hidden"></div>
				</p>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-FileSelector',
			DefaultInputExtensions: [ 'FileSelector' ],
			Template: /*HTML*/`
			<!-- InputType FileSelector {~D:Record.Hash~} {~D:Record.DataType~} (does not print) -->
			<div class="column {~ColumnWidth:Record~}">
				<input
					id="{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					{~D:Record.Macro.InputFullProperties~}
				/>
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<div class="control control-status is-expanded">
						<!-- the file input control -->
						<div {~D:Record.Macro.ControlAttr~} id="CONTROL-FOR-{~D:Record.Macro.RawHTMLID~}" class="is-fullwidth">
							<div class="input is-static has-text-text-60"><em>No file selected.</em></div>
						</div>
						<!-- dynamically filled with the preview of the file, if a record exists -->
						<div id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="input is-static is-hidden"></div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-FileSelector',
			DefaultInputExtensions: [ 'FileSelector' ],
			Template: /*HTML-Partial*/`
			<!-- InputType FileSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="control control-status is-expanded">
				<input
					id="TABULAR-DATA-FOR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					type="hidden"
					tabindex="-1"
					{~D:Record.Macro.InformaryTabular~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-FileSelector',
			DefaultInputExtensions: [ 'FileSelector' ],
			Template: /*HTML-Partial*/`
					 />
					<!-- the file input control -->
					<div {~D:Record.Macro.ControlAttr~} id="TABULAR-CONTROL-FOR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}" class="is-fullwidth">
						<div class="input is-static has-text-text-60"><em>No file selected.</em></div>
					</div>
					<!-- dynamically filled with the preview of the file, if a record exists -->
					<div id="TABULAR-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}" class="input is-static is-hidden"></div>
				</div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;
